/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Hubspot_Records_WaitingInputs */

const en_queue_hubspot_records_waiting = /** @type {(inputs: Queue_Hubspot_Records_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HubSpot records out of the directory`)
};

/**
* | output |
* | --- |
* | "HubSpot records out of the directory" |
*
* @param {Queue_Hubspot_Records_WaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_hubspot_records_waiting = /** @type {((inputs?: Queue_Hubspot_Records_WaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Hubspot_Records_WaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_hubspot_records_waiting(inputs)
});